import React from "react";

const HtmlForm = ({ strategieTemp = "" }) => {
    return(
        <div style={{maxWidth: "55%"}} dangerouslySetInnerHTML={{ __html: strategieTemp }} />
    );
}
export default HtmlForm;